// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader_preloader__32XrW","spinner":"preloader_spinner__2HQNb","spin":"preloader_spin__3i6kM"};